import { render, staticRenderFns } from "./CheckoutPagePaymentOption.vue?vue&type=template&id=b16558dc"
import script from "./CheckoutPagePaymentOption.vue?vue&type=script&lang=js"
export * from "./CheckoutPagePaymentOption.vue?vue&type=script&lang=js"
import style0 from "./CheckoutPagePaymentOption.vue?vue&type=style&index=0&id=b16558dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports